import React, { FC, ReactNode } from "react";
import "./CSS/AMPContainer.css";
import { Header } from "./Header/Header";
import { useLocation } from "react-router-dom";

interface FrameProps {
    /**
     * URL navigation when click on back button
     */
    ampUrl?: string;
    /**
     * Children components
     */
    children?: ReactNode
}
export const AMPContainer: FC<FrameProps> = ({ampUrl, children}) => {

   // const location = useLocation();
   const location = document.location.pathname.replace('/','')
    console.log(document.location.pathname.replace('/',''))

    return (
        <>
        <Header ampUrl={ampUrl}></Header>
        <div className={"main-container " + location}>
            {children}
        </div>
        </> 
    )
}
